import styled from 'styled-components'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { Heading, Warning } from '@lmc/ui-kit'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'

type MedicationStillInStockModalProps = {
  open: boolean
  medicationName: string
  quantity: number
  stockUnit: string
  onCancel: () => void
  onDispose: () => void
}

const MedicationStillInStockModal = ({
  open,
  medicationName,
  quantity,
  stockUnit,
  onCancel,
  onDispose
}: MedicationStillInStockModalProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={630}
      title={
        <TitleContainer>
          <IconWrapper>
            <Warning size={24} color="#DE7C12" />
          </IconWrapper>
          <ModalTitle>
            <Heading level={3}>{t('MEDICATION_STILL_IN_STOCK')}</Heading>
          </ModalTitle>
        </TitleContainer>
      }
    >
        <Divider />
      <ContentContainer>
        <Text>
          {t('MEDICATION_STILL_IN_STOCK_DESCRIPTION', {
            quantity,
            stockUnit,
            medication: medicationName
          })}
        </Text>
      </ContentContainer>
      <Divider />

      <ButtonsContainer>
        <Button onClick={onCancel} variant="default">
          {t('DISPOSE_LATER')}
        </Button>
        <Button onClick={onDispose} variant="danger">
          {t('DISPOSE')}
        </Button>
      </ButtonsContainer>
    </Modal>
  )
}

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`


const ModalTitle = styled.div`
  text-transform: none;
  font-weight: normal;
`

const ContentContainer = styled.div`
  padding: 24px 0;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  width: 24px;
`

export default MedicationStillInStockModal
